import { render } from "./EmptyPermissionComponent.vue?vue&type=template&id=99208008&scoped=true&lang=true"
import script from "./EmptyPermissionComponent.vue?vue&type=script&lang=js"
export * from "./EmptyPermissionComponent.vue?vue&type=script&lang=js"

import "./EmptyPermissionComponent.vue?vue&type=style&index=0&id=99208008&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99208008"]])

export default __exports__